<!-- KYMW1200 サイクル設定 -->
<ng-container *ngIf="model.isPast;else kymw1200contents">
  <div class="main-content">
    <div class="header">
      <span class="title">サイクル設定</span>
    </div>
    <div class="body">
      <ng-container *ngIf="model.isPast; then kymw1200contents"></ng-container>
    </div>
  </div>
</ng-container>

<ng-template #kymw1200contents>
  <div class="contents-area">
    <wj-accordion [isAnimated]="false" [allowCollapseAll]="true" [allowExpandMany]="true">
      <wj-accordion-pane id="acc_basicInfo" #acc_basicInfo>
        <div>基本情報</div>
        <div>
          <div class="element-column">
            <div class="block-row">
              <div class="element-column">
                <div class="column-list">
                  <!-- 媒体 -->
                  <label class="list-input-title">媒体</label>
                  <div class="list-input-content">
                    <app-versatile-combo-box #cmb_MediumType [(ngModel)]="model.mediumType" [listSource]="model.cycleMediumList"
                      valueField="Code" [width]="200" labelField="Name" [required]="true" [tabindex]="0" [visible]="true"
                      [autofocus]="false" forcedEnabledMode="true" (onChangedInvalid)="model.mediumType = ''">
                    </app-versatile-combo-box>
                  </div>
                  <!-- バイヤー -->
                  <label class="list-input-title">バイヤー</label>
                  <div class="list-input-content">
                    <app-versatile-combo-box #cmb_BuyerCode [(ngModel)]="model.buyerCode" [listSource]="model.buyerList"
                      valueField="Code" [width]="200" labelField="Name" [required]="true" [tabindex]="0" [dspBothField]="false"
                      [visible]="true" [autofocus]="false" forcedEnabledMode="true" (onChangedInvalid)="model.buyerCode = ''">
                    </app-versatile-combo-box>
                  </div>
                  <!-- 表示生協 -->
                  <label class="list-input-title">表示生協</label>
                  <div class="list-input-content">
                    <app-versatile-combo-box #cmb_CoopCode [(ngModel)]="model.coopCode" [listSource]="model.coopList"
                      valueField="CoopCode" [width]="200" labelField="CoopName" [required]="true" [tabindex]="0" [visible]="true"
                      [autofocus]="false" forcedEnabledMode="true" (onChangedInvalid)="model.coopCode = ''">
                    </app-versatile-combo-box>
                  </div>
                  <!-- 表示情報切替 -->
                  <label class="list-input-title">表示情報切替</label>
                  <div class="list-input-content">
                    <app-versatile-combo-box #cmb_SwitchType [(ngModel)]="model.switchType" [listSource]="model.switchTypeList"
                      valueField="CodeValue" [width]="200" labelField="CodeName" [required]="true" [tabindex]="0" [visible]="true"
                      [autofocus]="false" forcedEnabledMode="true" (onChangedInvalid)="model.switchType = ''">
                    </app-versatile-combo-box>
                  </div>
                  <!-- 表示受注コード -->
                  <label class="list-input-title">表示受注コード</label>
                  <div class="list-input-content">
                    <app-order-text-with-catalog #txti_OrderCodeFrom [autofocus]="true" [required]="true" [tabindex]="0"
                      [forcedEnabledMode]="'true'" [(ngModel)]="model.orderCodeFrom" [width]="85"
                      (onChangedCatalogId)="model.catalogIdFrom = $event">
                    </app-order-text-with-catalog>&#65374;
                    <app-order-text-with-catalog #txti_OrderCodeTo [autofocus]="true" [required]="false" [tabindex]="0"
                      [forcedEnabledMode]="'true'" [(ngModel)]="model.orderCodeTo" [width]="85"
                      (onChangedCatalogId)="model.catalogIdTo = $event">
                    </app-order-text-with-catalog>
                  </div>
                  <!-- 表示企画回 -->
                  <label class="list-input-title">表示企画回</label>
                  <div class="list-input-content">
                    <app-catalog-text-with-order #txti_CatalogIdFrom [autofocus]="true" [required]="true" [tabindex]="0"
                      [forcedEnabledMode]="'true'" [(ngModel)]="model.catalogIdFrom" [width]="85"
                      (onChangedOrderCode)="model.orderCodeFrom = $event">
                    </app-catalog-text-with-order>&#65374;
                    <app-catalog-text-with-order #txti_CatalogIdTo [autofocus]="true" [required]="false" [tabindex]="0"
                      [forcedEnabledMode]="'true'" [(ngModel)]="model.catalogIdTo" [width]="85"
                      (onChangedOrderCode)="model.orderCodeTo = $event">
                    </app-catalog-text-with-order>
                  </div>
                </div><!-- div column-list END -->
                <button #btn_Display class="btn-secondary" (click)="display()" forcedEnabledMode="none"
                  [tabindex]="0">表示</button>
              </div>
              <div *ngIf="model.isSupplier" class="grid-summary summary-comment">
                <h2>※注意</h2>
                <h2>商品選定は予定であり、確定した情報ではありません。</h2>
              </div>
              <div *ngIf="model.isBuyer || model.isLeader || model.isPast"
                [class]="model.isPast?'grid-summary-subwindow':'grid-summary'">
                <h2>企画回別予実
                  <button *ngIf="model.isBuyer || model.isLeader || model.isPast" #btn_UpdateSummary class="btn-secondary summary-update-button"
                    (click)="updateSummary()" [disabled]="!model.searchedMediumType || !(isEditMode || model.isLeader || model.isPast)"
                    forcedEnabledMode="none" [tabindex]="0">更新</button>
                </h2>
                <!-- FlexGrid -->
                <wj-transposed-grid #dtg_Summary [itemsSource]="model.summaryList" [headersVisibility]="'Row'"
                  [selectionMode]="'None'" horizontalScrollPolicy="on" verticalScrollPolicy="on" [allowDragging]="'Rows'"
                  [alternatingRowStep]="0" (loadedRows)="loadedRows(dtg_Summary)" (initialized)="initSummary(dtg_Summary)">
                  <!-- 企画回 -->
                  <wj-transposed-grid-row [header]="'企画回'" [binding]="'catalogId'" [isReadOnly]="true"></wj-transposed-grid-row>
                  <!-- 予算 -->
                  <wj-transposed-grid-row [header]="'予算'" [binding]="'dspBudget'" [isReadOnly]="true"
                    [align]="'right'"></wj-transposed-grid-row>
                  <!-- 計画数 -->
                  <wj-transposed-grid-row [header]="'計画数'" [binding]="'dspPlan'" [isReadOnly]="true"
                    [align]="'right'"></wj-transposed-grid-row>
                  <!-- 実績値 -->
                  <wj-transposed-grid-row [header]="'実績値'" [binding]="'dspResult'" [isReadOnly]="true"
                    [align]="'right'"></wj-transposed-grid-row>
                  <!-- 前年実績 -->
                  <wj-transposed-grid-row [header]="'前年実績'" [binding]="'dspPrevResult'" [isReadOnly]="true"
                    [align]="'right'"></wj-transposed-grid-row>
                  <!-- 選択表示項目 -->
                  <wj-transposed-grid-row [binding]="'switchValue'" [isReadOnly]="true"
                    [align]="'right'"></wj-transposed-grid-row>
                </wj-transposed-grid>
              </div><!-- div grid-summary END -->
            </div><!-- div block-row END -->
            <div *ngIf="model.isBuyer" class="element-row">
              <button #btn_SelectedList class="btn-secondary" (click)="openSelectedList()" forcedEnabledMode="none"
                [tabindex]="0">選定済商品数一覧表示</button>
              <button #btn_PastCycle class="btn-secondary" (click)="openPastCycle()" forcedEnabledMode="none"
                [tabindex]="0">過去サイクル確認</button>
            </div>
          </div>
        </div>
      </wj-accordion-pane>
    </wj-accordion>
    

    <div [class]="model.isBuyer || model.isSupplier || model.isOthers ? 'grid-main':'grid-main-nonbuyer'">
      <div class="other-mediums legend-flex-align" [ngClass]="model.isBuyer ? 'layout_end' : ''">
        <!-- 凡例 -->
        <label [ngClass]="model.isBuyer ? 'layout_end' : 'legend-center'" [style.flex]="model.isBuyer ? 'none' : '1'"
          style="height: 30px;align-items: end;">
          空白：未選択、〇：通常価、△：特価１、□：特価２、☆：特価３、背景青：特集、背景緑：表紙、背景オレンジ：裏表紙
        </label>
        <!-- 他媒体選択 -->
        <div *ngIf="model.isBuyer" class="column-list">
          <label class="list-input-title">他媒体選択</label>
          <div class="list-input-content">
            <input type="text" readonly [value]="model.dspOtherMediums" [style.width.px]="400" [tabindex]="-1" />
          </div>
        </div>
        <div class="element-row">
          <!-- 表示列設定 -->
          <div id="columnPicker" class="column-picker"></div>
          <!-- 列幅・表示列保存 -->
          <button class="btn-secondary" (click)="saveColumnWidthSettings()">列幅と表示列保存</button>
        </div>
      </div>
      <!-- FlexGrid -->
      <wj-flex-grid #dtg_Main [itemsSource]="model.itemList" [selectionMode]="'Row'" horizontalScrollPolicy="on"
        verticalScrollPolicy="on" [allowSorting]="false" [autoScroll]="true" [allowResizing]="'Columns'"
        (draggingRow)="onDraggingRow(dtg_Main, $event)" (draggedRow)="onDraggedRow(dtg_Main, $event)"
        (initialized)="initMain(dtg_Main);fixFrozenColumns(dtg_Main)" 
        [ngClass]="[model.isPast ? 'grid-inner-past': 'grid-inner', 
                    model.isSupplier ? 'is-supplier-grid': '',
                    model.isOthers ? 'is-others-grid': '',
                    model.isBuyer ? 'is-buyer-grid' : '',
                    !acc_basicInfo.isCollapsed ? 'accordion-open': '']">
        <wj-flex-grid-filter #fltr_Main></wj-flex-grid-filter>
        <!-- 媒体区分 -->
        <wj-flex-grid-column [header]="'媒体区分'" [minWidth]="5" [width]="100" [binding]="'mediumName'" [isReadOnly]="true">
        </wj-flex-grid-column>
        <!-- 部門 -->
        <wj-flex-grid-column [header]="'部門'" [minWidth]="5" [width]="100" [binding]="'className'" [isReadOnly]="true">
        </wj-flex-grid-column>
        <!-- 大分類名 -->
        <wj-flex-grid-column [header]="'大分類名'" [minWidth]="5" [width]="100" [binding]="'largeClassName'" [isReadOnly]="true">
        </wj-flex-grid-column>
        <!-- 中分類名 -->
        <wj-flex-grid-column [header]="'中分類名'" [minWidth]="5" [width]="90" [binding]="'middleClassName'" [isReadOnly]="true">
        </wj-flex-grid-column>
        <!-- 小分類名 -->
        <wj-flex-grid-column [header]="'小分類名'" [minWidth]="5" [width]="90" [binding]="'smallClassName'" [isReadOnly]="true">
        </wj-flex-grid-column>
        <!-- 分類タグ情報 -->
        <wj-flex-grid-column [header]="'分類タグ\n情報'" [multiLine]="true" [minWidth]="5" [width]="100" [binding]="'categoryTagName'"
          [isReadOnly]="true" [cssClass]="isEditMode?'embedded-cell':''">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <app-versatile-combo-box *ngIf="isEditMode && cell.item"
              [(ngModel)]="cell.item.categoryTagId" [listSource]="model.itemList[cell.row.index].tagSelectionList"
              valueField="tagId" labelField="tagName" [blank]="true" [blankVal]="''" [tabindex]="0" [visible]="true"
              [autofocus]="false" forcedEnabledMode="true" (onChangedInvalid)="cell.item.categoryTagId = ''"
              (change)="eventCategoryTagId_CHANGEHandler(cell.item)">
            </app-versatile-combo-box>
            <div *ngIf="!isEditMode">{{cell.item.categoryTagName}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <!-- 他タグ情報 -->
        <wj-flex-grid-column [header]="'他タグ情報'" [minWidth]="5" [width]="100" [binding]="'dspTagNames'" [isReadOnly]="true">
        </wj-flex-grid-column>
        <!-- ＪＡＮコード -->
        <wj-flex-grid-column [header]="'ＪＡＮコード'" [minWidth]="5" [width]="140" [binding]="'janCode'" [isReadOnly]="true">
        </wj-flex-grid-column>
        <!-- アイテムコード -->
        <wj-flex-grid-column [header]="'アイテム\nコード'" [multiLine]="true" [minWidth]="5" [width]="100" [binding]="'itemCode'"
          [isReadOnly]="true">
        </wj-flex-grid-column>
        <!-- 関連Ｐコード -->
        <wj-flex-grid-column [header]="'関連\nＰコード'" [multiLine]="true" [minWidth]="5" [width]="100" [binding]="'relationPcode'"
          [isReadOnly]="true">
        </wj-flex-grid-column>
        <!-- Ｐコード -->
        <wj-flex-grid-column [header]="'Ｐコード'" [minWidth]="5" [width]="100" [binding]="'pcode'" [isReadOnly]="true">
        </wj-flex-grid-column>
        <!-- 商品名 -->
        <wj-flex-grid-column [header]="'商品名'" [minWidth]="5" [width]="200" [binding]="'goodsName'" [isReadOnly]="true">
        </wj-flex-grid-column>
        <!-- 規格名 -->
        <wj-flex-grid-column [header]="'規格名'" [minWidth]="5" [width]="200" [binding]="'standardName'" [isReadOnly]="true">
        </wj-flex-grid-column>
        <!-- 支払先取引先 -->
        <wj-flex-grid-column [header]="'支払先取引先'" [minWidth]="5" [width]="140" [binding]="'payeeClient'" [isReadOnly]="true">
        </wj-flex-grid-column>
        <!-- 発注先取引先 -->
        <wj-flex-grid-column [header]="'発注先取引先'" [minWidth]="5" [width]="140" [binding]="'orderClient'" [isReadOnly]="true">
        </wj-flex-grid-column>
        <!-- 取扱生協 -->
        <wj-flex-grid-column [header]="'取扱生協'" [minWidth]="5" [width]="100" [binding]="'dspAllCoop'" [isReadOnly]="true">
        </wj-flex-grid-column>
        <!-- 取扱期間（終了） -->
        <wj-flex-grid-column [header]="'取扱期間\n（終了）'" [multiLine]="true" [minWidth]="5" [width]="100" [binding]="'applyTermEnd'"
          [isReadOnly]="true">
        </wj-flex-grid-column>
        <!-- 本体供給価格（通常） -->
        <wj-flex-grid-column [header]="'本体供給価格\n（通常）'" [multiLine]="true" [minWidth]="5" [width]="116" [binding]="'supplyTaxWithoutStd'" [isReadOnly]="true" [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'right'">{{cell.item.supplyTaxWithoutStd | comma}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <!-- 単仕入価格（通常） -->
        <wj-flex-grid-column [header]="'単仕入価格\n（通常）'" [multiLine]="true" [minWidth]="5" [width]="98" [binding]="'costPriceStandard'" [isReadOnly]="true" [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'right'">{{cell.item.costPriceStandard | comma}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <!-- GPR（通常） -->
        <wj-flex-grid-column [header]="'GPR\n（通常）'" [multiLine]="true" [minWidth]="5" [width]="78" [binding]="'gprStd'" [isReadOnly]="true" [align]="'right'">
        </wj-flex-grid-column>
        <!-- 本体供給価格（特１） -->
        <wj-flex-grid-column [header]="'本体供給価格\n（特１）'" [multiLine]="true" [minWidth]="5" [width]="116" [binding]="'supplyTaxWithoutSpc1'" [isReadOnly]="true" [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'right'">{{cell.item.supplyTaxWithoutSpc1 | comma}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <!-- 単仕入価格（特１） -->
        <wj-flex-grid-column [header]="'単仕入価格\n（特１）'" [multiLine]="true" [minWidth]="5" [width]="98" [binding]="'costPriceSpecial1'" [isReadOnly]="true" [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'right'">{{cell.item.costPriceSpecial1 | comma}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <!-- GPR（特１） -->
        <wj-flex-grid-column [header]="'GPR\n（特１）'" [multiLine]="true" [minWidth]="5" [width]="78" [binding]="'gprSpc1'" [isReadOnly]="true" [align]="'right'">
        </wj-flex-grid-column>
        <!-- 本体供給価格（特２） -->
        <wj-flex-grid-column [header]="'本体供給価格\n（特２）'" [multiLine]="true" [minWidth]="5" [width]="116" [binding]="'supplyTaxWithoutSpc2'" [isReadOnly]="true" [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'right'">{{cell.item.supplyTaxWithoutSpc2 | comma}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <!-- 単仕入価格（特２） -->
        <wj-flex-grid-column [header]="'単仕入価格\n（特２）'" [multiLine]="true" [minWidth]="5" [width]="98" [binding]="'costPriceSpecial2'" [isReadOnly]="true" [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'right'">{{cell.item.costPriceSpecial2 | comma}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <!-- GPR（特２） -->
        <wj-flex-grid-column [header]="'GPR\n（特２）'" [multiLine]="true" [minWidth]="5" [width]="78" [binding]="'gprSpc2'" [isReadOnly]="true" [align]="'right'">
        </wj-flex-grid-column>
        <!-- 商品メモ -->
        <wj-flex-grid-column [header]="'商品メモ'" [minWidth]="5" [width]="200" [binding]="'goodsMemo'" [isReadOnly]="true"
          [cssClass]="'embedded-cell'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <input *ngIf="isEditMode" class="text-label-normal embedded-input" type="text" plessInputTextSub
              [restrict]="'[ -￮]'" [(ngModel)]="cell.item.goodsMemo" [maxlength]="200" [tabindex]="0">
            <div *ngIf="!isEditMode">{{cell.item.goodsMemo}}</div>
          </ng-template>
        </wj-flex-grid-column>

        <!-- 企画回別情報 -->
        <ng-template ngFor let-el [ngForOf]="model.filteredOrderList">
          <wj-flex-grid-column [header]="el.OrderCode" [binding]="model.isPricePatternMode ? 'catalogInfoMap.' + el.OrderCode + '.dispPatternAndMemo' : 'catalogInfoMap.' + el.OrderCode + '.dispValue'" [minWidth]="5" [width]="model.isPricePatternMode?120:150" [isReadOnly]="true">
            <ng-template wjFlexGridCellTemplate [cellType]="'ColumnHeader'" let-cell="cell">
              <div class="order-head-div" [ngClass]="!model.isPricePatternMode ? 'order-head-right' : 'order-head-center'">
                <app-radio-label *ngIf="cell.row.index === 0 && ( model.isBuyer || model.isSupplier || model.isOthers )"
                  [disabled]="disableRadioOrderCode" [value]="el.OrderCode" [(ngModel)]="model.radioOrderCode" [tabindex]="-1">
                </app-radio-label>
                <span *ngIf="cell.row.index === 0">{{el.CatalogID}}</span>
                <span *ngIf="cell.row.index !== 0">{{el.OrderCode}}</span>
              </div>
            </ng-template>
            <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
              <!-- 価格パターン -->
              <div
                *ngIf="model.isPricePatternMode && cell.item.catalogInfoMap[el.OrderCode]"
                class="embedded-input align-center"
                [innerHtml]="getPricePatternAndCatalogMemo(cell.item.catalogInfoMap[el.OrderCode])"
                (click)="getOtherMediums(cell.item.mediumType,cell.item.pcode,el.OrderCode)">
              </div>
              <!-- 計画数・実績値 -->
              <div *ngIf="!model.isPricePatternMode && cell.item.catalogInfoMap[el.OrderCode]" class="embedded-input" style="text-align: right;">
                {{cell.item.catalogInfoMap[el.OrderCode].dispValue}}
              </div>
            </ng-template>
          </wj-flex-grid-column>
        </ng-template>

        <!-- 商品別個数集計 -->
        <wj-flex-grid-column [header]="'商品別個数\n集計'" [multiLine]="true" [minWidth]="5" [width]="110" [binding]="'dspNumSum'"
          [isReadOnly]="true" [align]="'right'">
        </wj-flex-grid-column>
        <!-- 商品別金額集計（千円） -->
        <wj-flex-grid-column [header]="'商品別金額\n集計（千円）'" [multiLine]="true" [minWidth]="5" [width]="110" [binding]="'dspPriceSum'"
          [isReadOnly]="true" [align]="'right'">
        </wj-flex-grid-column>
      </wj-flex-grid>
    </div><!-- div grid-container END -->
  </div>

  <!-- フッター バイヤー用 -->
  <footer *ngIf="model.isBuyer" class="footer-buttons">
    <!-- button 企画回別商品一覧表示 -->
    <button #btn_CatalogItemList class="btn-secondary" (click)="openCatalogItemList()" forcedEnabledMode="none"
      [disabled]="!model.searchedMediumType" [tabindex]="0">企画回別商品一覧</button>
    <!-- button ダウンロード -->
    <button #btn_Download class="btn-secondary" (click)="download()" forcedEnabledMode="none"
      [disabled]="!model.searchedMediumType" [tabindex]="0">ダウンロード</button>
    <!-- button 保存 -->
    <button #btn_Save class="btn-primary" (click)="save()" forcedEnabledMode="none"
      [disabled]="!isEditMode || !model.searchedMediumType" [tabindex]="0">保存</button>
  </footer>

  <!-- フッター 取引先用 -->
  <footer *ngIf="model.isSupplier" class="footer-buttons">
    <!-- button 企画回別商品一覧表示 -->
    <button #btn_CatalogItemList class="btn-secondary" (click)="openCatalogItemList()" forcedEnabledMode="none"
      [tabindex]="0">企画回別商品一覧</button>
    <!-- button ダウンロード -->
    <button #btn_Download class="btn-secondary" (click)="download()" forcedEnabledMode="none"
      [tabindex]="0">ダウンロード</button>
  </footer>

  <!-- フッター その他用 -->
  <footer *ngIf="model.isOthers" class="footer-buttons">
    <!-- button 企画回別商品一覧表示 -->
    <button #btn_CatalogItemList class="btn-secondary" (click)="openCatalogItemList()" forcedEnabledMode="none"
      [tabindex]="0">企画回別商品一覧</button>
  </footer>

</ng-template>